import script from "./BrowseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseDetails.vue?vue&type=script&setup=true&lang=js"

import "./BrowseDetails.vue?vue&type=style&index=0&id=1bcba9aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcba9aa"]])

export default __exports__